import { authApi } from "./redux/api";

export const AuthFeatureMiddlewares = [
  authApi.middleware,
];

export const AuthFeatureReducers = {
  [authApi.reducerPath]: authApi.reducer,
};